
import { createClient } from '@supabase/supabase-js';

const getEnv = (key: string) => {
    if (typeof import.meta !== 'undefined' && (import.meta as any).env && (import.meta as any).env[key]) {
        return (import.meta as any).env[key];
    }
    try {
        if (typeof process !== 'undefined' && process.env && process.env[key]) {
            return process.env[key];
        }
    } catch (e) {}
    return '';
};

export const VITE_SUPABASE_URL = getEnv('VITE_SUPABASE_URL');
export const VITE_SUPABASE_ANON_KEY = getEnv('VITE_SUPABASE_ANON_KEY');

const validUrl = VITE_SUPABASE_URL && VITE_SUPABASE_URL.startsWith('http') ? VITE_SUPABASE_URL : 'https://placeholder.supabase.co';
const validKey = VITE_SUPABASE_ANON_KEY || 'placeholder';

export const isConfigured = VITE_SUPABASE_URL && VITE_SUPABASE_ANON_KEY && VITE_SUPABASE_URL !== 'undefined' && !VITE_SUPABASE_URL.includes('placeholder');

// VIKTIGT: Klient-instansen ska INTE spara sessioner i localStorage.
// Vi förlitar oss helt på att servern skickar cookies via API:et.
export const supabase = createClient(validUrl, validKey, {
  auth: {
    persistSession: false, 
    autoRefreshToken: false, 
    detectSessionInUrl: false,
  },
  global: {
    headers: { 'x-application-name': 'coffeenova' }
  }
});

export const checkSupabaseConnection = async (): Promise<{ success: boolean; message: string; schemaError?: boolean; rawError?: any }> => {
  try {
    if (!isConfigured) return { success: false, message: "Miljövariabler saknas" };
    
    // Vi kollar bara att vi kan nå servern, inte om vi har en session
    const { error, status } = await supabase.from('site_content').select('key').limit(1);
    
    if (error) {
        if (error.code === '42P01') return { success: false, message: "Tabeller saknas (42P01)", schemaError: true, rawError: error };
        // Ignorera behörighetsfel (401/403) här, det betyder bara att vi har kontakt men inte är inloggade
        if (error.code !== 'PGRST301' && status !== 401 && status !== 403) {
             return { success: false, message: `${error.message} (HTTP ${status || error.code})`, rawError: error };
        }
    }
    
    return { success: true, message: "Ansluten till databasen!" };
  } catch (e: any) {
    return { success: false, message: e.message || "Okänt nätverksfel", rawError: e };
  }
};

// Exponera klienten i konsolen ENBART lokalt (felsökning). I produktion
// skulle den göra det trivialt att anropa databasen direkt med den
// inloggades behörigheter från DevTools.
if (import.meta.env.DEV && typeof window !== 'undefined') {
    (window as any).supabase = supabase;
}
